// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ns-0";
export var assigneeDetails = "_ns-1";
export var assigneeInfo = "_ns-2";
export var dropdownContainer = "_ns-4";
export var dropdownImage = "_ns-5";
export var editAssigneeInfo = "_ns-3";
export var editAssigneeModalContainer = "_ns-6";
export var hidden = "_ns-8";
export var input = "_ns-7";